export default __webpack_public_path__ + "static/media/pfd_050.bc9ee9a6.jpg";